import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = ({ children }) => {
  const { isLoggedIn, loading } = useAuth();

  if (loading) {
    return null; // or a loading spinner
  }

  const customerType = localStorage.getItem("CustomerType");

  if (customerType === "AGENT") {
    return <Navigate to="/" replace />;  
  }

  return isLoggedIn ? children : <Navigate to="/" />;
};

export default PrivateRoute;
